module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Bill');
			} else {
				cannot('manage', 'Bill');
			}
		});

		return { ability };
	}
};
